module.exports = __webpack_public_path__ + "static/media/34DSS5.8d94a11f.jpg";